import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { Icon } from '@atlas/ui';

import { CDN_TYPE_BASE, imageUrlCDN } from 'common/utils/utils';

const QuickDepositPaymentMethod = ({
  isDropdownOpen,
  paymentMethod,
  setIsDropdownOpen,
  withDropdown,
}) => {
  const { desktopImageLink } = paymentMethod;

  const [isImageError, setIsImageError] = useState(false);

  useEffect(() => {
    setIsImageError(false);
  }, [desktopImageLink]);

  const props = withDropdown
    ? { onClick: () => setIsDropdownOpen(prev => !prev), role: 'button' }
    : {};

  const srcUrl = desktopImageLink ? imageUrlCDN(desktopImageLink, CDN_TYPE_BASE) : null;

  const showDefaultIcon = !srcUrl || isImageError;

  return (
    <div
      className={cx('quick-deposit-payment-method', {
        open: isDropdownOpen,
        'with-dropdown': withDropdown,
      })}
    >
      <div className="payment-method-wrapper" {...props}>
        <div className={cx('payment-method-image', { 'default-icon': showDefaultIcon })}>
          {showDefaultIcon ? (
            <Icon name="money" />
          ) : (
            <img alt="" onError={() => setIsImageError(true)} src={srcUrl} />
          )}
        </div>
        {withDropdown && (
          <Icon className="arrow" name={isDropdownOpen ? 'arrow-up' : 'arrow-down'} />
        )}
      </div>
    </div>
  );
};

QuickDepositPaymentMethod.propTypes = {
  isDropdownOpen: PropTypes.bool,
  paymentMethod: PropTypes.shape({
    desktopImageLink: PropTypes.string,
  }),
  setIsDropdownOpen: PropTypes.func,
  withDropdown: PropTypes.bool,
};

export default QuickDepositPaymentMethod;
